import { exception } from '../../util/decorators'
import BaseApi from './BaseApi'
const domain = 'https://service.sanmanuela.net'

export default class NewsApi extends BaseApi {
    postRequest(response, url) {
        if (response.code == 1) {
            return response.data
        }
        throw new Error(response.msg)
    }

    @exception('获取直播列表失败')
    getLiveRooms(page, limit) {
        return this.httpGet(domain + `/api/live.room/index`, { page, limit })
    }

    @exception('获取直播详情失败')
    getLiveDetail(id) {
        return this.httpGet(domain + `/api/live.room/detail`, { id })
    }

    @exception('点赞失败')
    postVote(id) {
        return this.httpGet(domain + `/api/live.room/vote`, { id })
    }

    postHit(ac, id) {
        return this.httpPost(domain + `/api/common.report/hit`, { ac, id })
    }
}



// WEBPACK FOOTER //
// ./src/service/api/livesApi.js